import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';

interface ProcessStep {
  title: string;
  icon: string;
  image: {
    url: string,
    alt: string,
    srcset: string
  };
  content: {
    points: Array<{
      title: string;
      description: string;
    }>;
  };
}

@Component({
  selector: 'app-finance-education-plan',
  standalone: true,
  imports: [CommonModule, RouterModule, ApplyButtonComponent],
  templateUrl: './finance-education-plan.component.html',
  styleUrls: ['./finance-education-plan.component.scss']
})
export class FinanceEducationPlanComponent implements OnInit, OnDestroy {
  
  steps: ProcessStep[] = [
    {
      title: 'Billion Mindset Mastery:',
      icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61ea27777e7eef8bc1_icon_prozess.svg',
      image: {
        url: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b1022a083e56464db35d_img_prozess-2.avif',
        alt: 'Ein Mann hält einen Vortrag',
        srcset: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b1022a083e56464db35d_img_prozess-2-p-500.avif 500w, https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b1022a083e56464db35d_img_prozess-2.avif 885w'
      },
      content: {
        points: [
          {
            title: 'Entfessle dein inneres Potenzial:',
            description: 'Entwickle ein Sieger-Mindset, das dich unaufhaltsam macht.'
          },
          {
            title: 'Erreiche mentale Klarheit:',
            description: 'Meistere revolutionäre Techniken, die dich fokussiert und motiviert halten.'
          },
          {
            title: 'Überwinde alle Hürden:',
            description: 'Lerne, wie du mentale Blockaden in transformative Chancen verwandelst.'
          }
        ]
      }
    },
    {
      title: 'Trading Strategies - They don\'t want You to know!',
      icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab6162704028f9b6fe90_icon_prozess-1.svg',
      image: {
        url: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b102022b27a0554a8008_img_prozess-1.avif',
        alt: 'Ein Mann mit definierter Jawline',
        srcset: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b102022b27a0554a8008_img_prozess-1-p-500.avif 500w, https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b102022b27a0554a8008_img_prozess-1.avif 885w'
      },
      content: {
        points: [
          {
            title: 'Geheimnisse der Marktmeister:',
            description: 'Erhalte Einblicke in unterschiedliche Trading-Strategien erfahrener Trader und deren praktische Anwendung.'
          },
          {
            title: 'Präzision und Timing:',
            description: 'Beherrsche die Kunst des perfekten Einstiegs und Ausstiegs mit chirurgischer Genauigkeit.'
          },
          {
            title: 'Trading-Techniken:',
            description: 'Nutze avantgardistische Methoden, die dich von der Konkurrenz abheben.'
          }
        ]
      }
    },
    {
      title: 'Skalierung & Automatisierung:',
      icon: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61c7e88d133d72cfeb_icon_prozess-2.svg',
      image: {
        url: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b10237d76858242c0162_img_prozess.avif',
        alt: 'Ein Mann beim trading',
        srcset: 'https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b10237d76858242c0162_img_prozess-p-500.avif 500w, https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2b10237d76858242c0162_img_prozess.avif 885w'
      },
      content: {
        points: [
          {
            title: 'Arbeite smarter, nicht härter:',
            description: 'Erhalte Schritt-für-Schritt-Anleitungen zur Konfiguration von Trading-Bots auf deinen eigenen Konten.'
          },
          {
            title: 'Exponentielles Wachstum:',
            description: 'Erfahre, wie du Arbeitsabläufe so strukturierst, dass sie langfristig effizienter und leichter skalierbar werden.'
          },
          {
            title: 'Systeme schaffen, die dich entlasten:',
            description: 'Erarbeite dir Wissen, wie du eigenverantwortlich Systeme aufsetzt, die Marktchancen automatisch nutzen können.'
          }
        ]
      }
    }
  ];

  constructor() {}

  ngOnInit() {
  }

  ngOnDestroy() {
  }
} 